const ForgotPassword: React.FunctionComponent<{}> = () => {
    return (<>Forgot password</>)
}
export default ForgotPassword